(function () {
  /* ============================================================
     Rhythmixed Package Builder — pkg-builder.js
     Fixes applied:
       #2  — EFFECT_LEVELS driven by CSS variables
       #4  — Transition string/object mismatch fixed
       #6  — Session restore race condition fixed
       #11 — Modal total row styled correctly
       #16 — Improved error messaging on submit failure
       #18 — Edit points shown in order summary
     ============================================================ */

  var SESSION_KEY = 'pkg_builder_state';

  var DEFAULT = {
    packages: {
      standard: {
        name: 'Standard', basePrice: 35, extraPricePerTrack: 15, maxTracks: 3,
        maxEffectLevels: 2, editPointsPerTrack: 3,
        description: 'Ideal for performance-ready mixes without the complexities of full-scale production. Whether you\'re starting from scratch or already have a mix that needs refining, this package focuses on creating natural transitions, integrated into a cohesive final product.',
        variantId: '43238656475241',
        turnaroundOptions: [
          { label: '11-14 Days', priceAdjustment: -10 },
          { label: '7-10 Days',  priceAdjustment: 0   },
          { label: '4-6 Days',   priceAdjustment: 20  },
          { label: '1-3 Days',   priceAdjustment: 50  }
        ],
        transitions: {
          intro:      [{ value: 'none', label: 'None' }, { value: 'fade_in', label: 'Fade In' }],
          transition: [{ value: 'none', label: 'None' }, { value: 'invisible_mix', label: 'Invisible Mix' }],
          outro:      [{ value: 'none', label: 'None' }, { value: 'fade_out', label: 'Fade Out' }]
        }
      },
      premium: {
        name: 'Premium', basePrice: 60, extraPricePerTrack: 25, maxTracks: 5,
        maxEffectLevels: 3, editPointsPerTrack: 4,
        description: 'Ideal for choreography with advanced musicality and dynamics. More than just a clean mix, this package creates momentum, highlights performance moments, and elevates energy through layered edits and dynamic transitions.',
        variantId: '43238656508009',
        turnaroundOptions: [
          { label: '11-14 Days', priceAdjustment: -10 },
          { label: '7-10 Days',  priceAdjustment: 0   },
          { label: '4-6 Days',   priceAdjustment: 20  },
          { label: '1-3 Days',   priceAdjustment: 50  }
        ],
        transitions: {
          intro:      [{ value: 'none', label: 'None' }, { value: 'fade_in', label: 'Fade In' }, { value: 'impact', label: 'Impact' }],
          transition: [{ value: 'none', label: 'None' }, { value: 'invisible_mix', label: 'Invisible Mix' }, { value: 'sound_effects', label: 'Sound Effects' }],
          outro:      [{ value: 'none', label: 'None' }, { value: 'fade_out', label: 'Fade Out' }, { value: 'impact', label: 'Impact' }]
        }
      },
      elite: {
        name: 'Elite', basePrice: 75, extraPricePerTrack: 30, maxTracks: 7,
        maxEffectLevels: 5, editPointsPerTrack: 5,
        description: 'Ideal for national competitions, professional showcases, promotional content, and concept videos where every second matters. A fully customised music production service tailored for elite performers, studios, and creative directors.',
        variantId: '43238656540777',
        turnaroundOptions: [
          { label: '11-14 Days', priceAdjustment: -10 },
          { label: '7-10 Days',  priceAdjustment: 0   },
          { label: '4-6 Days',   priceAdjustment: 20  },
          { label: '1-3 Days',   priceAdjustment: 50  }
        ],
        transitions: {
          intro:      [{ value: 'none', label: 'None' }, { value: 'fade_in', label: 'Fade In' }, { value: 'impact', label: 'Impact' }, { value: 'cinematic_intro', label: 'Cinematic Intro' }],
          transition: [{ value: 'none', label: 'None' }, { value: 'invisible_mix', label: 'Invisible Mix' }, { value: 'sound_effects', label: 'Sound Effects' }, { value: 'element_crossfade', label: 'Element Crossfade' }, { value: 'orchestral_blend', label: 'Orchestral Blend' }],
          outro:      [{ value: 'none', label: 'None' }, { value: 'fade_out', label: 'Fade Out' }, { value: 'impact', label: 'Impact' }, { value: 'cinematic_outro', label: 'Cinematic Outro' }]
        }
      }
    },
    effectLevels: ['Clean', 'Subtle', 'Enhanced', 'Epic', 'Full-Out'],
    addOns: [
      { id: 'clean',              name: 'Clean Version',      key: 'clean',              price: 14,  description: 'Explicit words removed.',                              perTrack: true,  inputType: 'none'         },
      { id: 'acapella',          name: 'Acapella',           key: 'acapella',           price: 28,  description: 'Isolated vocal track.',                                perTrack: false, inputType: 'none'         },
      { id: 'remove_noise',      name: 'Remove Noise',       key: 'remove_noise',       price: 28,  description: 'Background noise or other noise removal.',             perTrack: false, inputType: 'none'         },
      { id: 'speed_up',          name: 'Speed Up',           key: 'speed_up',           price: 7,   description: 'Speed up the track to your preferred BPM.',           perTrack: false, inputType: 'bpm'          },
      { id: 'slow_down',         name: 'Slow Down',          key: 'slow_down',          price: 7,   description: 'Slow down the edit to your chosen BPM.',              perTrack: false, inputType: 'bpm'          },
      { id: 'change_key',        name: 'Change Key',         key: 'change_key',         price: 10,  description: 'Transpose the edit to your preferred key.',           perTrack: true,  inputType: 'key_selector' },
      { id: 'custom_dance_break',name: 'Custom Dance Break', key: 'custom_dance_break', price: 105, description: 'Fully custom dance break. Maximum one per edit.',      perTrack: false, inputType: 'text'         },
      { id: 'custom_intro',      name: 'Custom Intro',       key: 'custom_intro',       price: 50,  description: 'Fully custom intro tailored to your mix.',            perTrack: false, inputType: 'text'         },
      { id: 'custom_outro',      name: 'Custom Outro',       key: 'custom_outro',       price: 50,  description: 'Fully custom outro tailored to your mix.',            perTrack: false, inputType: 'text'         }
    ],
    genres: ['Hip-Hop', 'Commercial Jazz', 'Heels', 'Contemporary', 'Lyrical',
            'Broadway Jazz', 'Cabaret', 'Tap', 'Musical Theatre', 'Latin', 'Other']
  };


  /* ── Config ── */
  var cfg;
  try {
    cfg = window.PKG_CONFIG || DEFAULT;
    if (typeof cfg !== 'object' || !cfg.packages) throw new Error('Invalid config');
    cfg.effectLevels = cfg.effectLevels || DEFAULT.effectLevels;
    cfg.addOns       = cfg.addOns       || DEFAULT.addOns;
    cfg.genres       = cfg.genres       || DEFAULT.genres;
    cfg.packages     = cfg.packages     || DEFAULT.packages;
    ['standard', 'premium', 'elite'].forEach(function (k) {
      cfg.packages[k] = cfg.packages[k] || DEFAULT.packages[k];
    });
  } catch (e) {
    console.error('[pkg-builder] Config error:', e);
    var errEl = document.getElementById('pkg-config-error');
    if (errEl) errEl.hidden = false;
    return;
  }

  /* ── Currency ── */
  var currency = Shopify.currency.active;
  var rate     = parseFloat(Shopify.currency.rate);
  function formatPrice(aud) {
    return (aud * rate).toLocaleString(undefined, {
      style: 'currency', currency: currency, minimumFractionDigits: 2
    });
  }

  /* ── Effect level colour map
     Fix #2: read from CSS variables so ce-tokens.css is the single source of truth ── */
  function getEffectLevelStyle(index) {
    var root = document.documentElement;
    var cs   = getComputedStyle(root);
    var bg   = cs.getPropertyValue('--ce-eff-' + index + '-bg').trim();
    var text = cs.getPropertyValue('--ce-eff-' + index + '-text').trim();
    // Fallback to hardcoded values if tokens not loaded
    var fallbacks = {
      1: { bg: '#fde8d8', text: '#a84400' },
      2: { bg: '#fbd0b0', text: '#943b00' },
      3: { bg: '#f9b080', text: '#7a2e00' },
      4: { bg: '#f68840', text: '#5a1e00' },
      5: { bg: '#f26522', text: '#ffffff' }
    };
    return {
      bg:   bg   || (fallbacks[index] && fallbacks[index].bg)   || '#f26522',
      text: text || (fallbacks[index] && fallbacks[index].text) || '#ffffff'
    };
  }

  var EFFECT_LEVEL_LABELS = ['Clean', 'Subtle', 'Enhanced', 'Epic', 'Full-Out'];

  /* ── Fix #4: Normalise transition value — handles both strings and {value,label} objects ── */
  function transitionValue(t) {
    if (!t) return '';
    if (typeof t === 'string') return t;
    return t.value || t.label || '';
  }

  function transitionLabel(t) {
    if (!t) return '';
    if (typeof t === 'string') return t;
    return t.label || t.value || '';
  }

  /* ── Aggregate transitions — Fix #4: normalise to strings for comparison ── */
  var ALL_INTRO = [], ALL_TRANS = [], ALL_OUTRO = [];
  ['standard', 'premium', 'elite'].forEach(function (k) {
    var t = (cfg.packages[k] && cfg.packages[k].transitions) || {};
    (t.intro      || []).forEach(function (o) {
      var v = transitionValue(o);
      if (ALL_INTRO.indexOf(v) === -1) ALL_INTRO.push(v);
    });
    (t.transition || []).forEach(function (o) {
      var v = transitionValue(o);
      if (ALL_TRANS.indexOf(v) === -1) ALL_TRANS.push(v);
    });
    (t.outro      || []).forEach(function (o) {
      var v = transitionValue(o);
      if (ALL_OUTRO.indexOf(v) === -1) ALL_OUTRO.push(v);
    });
  });
  if (!ALL_INTRO.length) ALL_INTRO = ['None', 'Fade In', 'Impact', 'Cinematic Intro'];
  if (!ALL_TRANS.length) ALL_TRANS = ['None', 'Invisible Mix', 'Sound Effects', 'Element Crossfade', 'Orchestral Blend'];
  if (!ALL_OUTRO.length) ALL_OUTRO = ['None', 'Fade Out', 'Impact', 'Cinematic Outro'];

  /* ── State ── */
  var selectedPkg      = null;
  var trackCount       = 1;
  var turnaroundChoice = null;
  var submitCooldown   = false;
  var els              = {};

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }
  var debouncedUpdateTotal = debounce(updateTotal, 50);

  /* ── Count customisation options — Fix #4: normalise transitions ── */
  function countCustomisationOptions(p) {
    var t = p.transitions || {};
    var effCount   = p.maxEffectLevels || 0;
    var introCount = (t.intro      || []).filter(function (o) { return transitionValue(o) !== 'None'; }).length;
    var transCount = (t.transition || []).filter(function (o) { return transitionValue(o) !== 'None'; }).length;
    var outroCount = (t.outro      || []).filter(function (o) { return transitionValue(o) !== 'None'; }).length;
    return effCount + introCount + transCount + outroCount;
  }

  /* ============================================================
     SESSION STORAGE
     ============================================================ */
  function saveState() {
    try {
      var checkedAddons = [];
      document.querySelectorAll('.addon-card input:checked').forEach(function (cb) {
        checkedAddons.push(cb.dataset.name);
      });
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        pkgKey:          selectedPkg ? selectedPkg.key : null,
        trackCount:      trackCount,
        turnaroundLabel: turnaroundChoice ? turnaroundChoice.label : null,
        checkedAddons:   checkedAddons,
        editTitle:       els.editTitle ? els.editTitle.value : '',
        genre:           els.genre ? els.genre.value : ''
      }));
    } catch (e) {}
  }

  /* Fix #6: restoreState now waits for renderTurnaroundOptions to complete
     before attempting to re-select the saved turnaround ── */
  function restoreState() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (s.editTitle && els.editTitle) els.editTitle.value = s.editTitle;
      if (s.genre && els.genre)         els.genre.value     = s.genre;
      if (s.pkgKey) {
        var card = document.querySelector('.pkg-card[data-pkg="' + s.pkgKey + '"]');
        if (card) {
          // selectPackage calls renderTurnaroundOptions internally
          selectPackage(card, true);
          // Now safe to restore track count and turnaround
          trackCount = Math.min(s.trackCount || 1, selectedPkg ? selectedPkg.max : 1);
          renderTrackBoxes();
          updateTrackPriceIndicator();
          // Restore turnaround after renderTurnaroundOptions has run
          if (s.turnaroundLabel && selectedPkg) {
            cfg.packages[selectedPkg.key].turnaroundOptions.forEach(function (opt) {
              if (opt.label === s.turnaroundLabel) {
                turnaroundChoice = opt;
                document.querySelectorAll('.turnaround-card').forEach(function (c) {
                  if (c.dataset.label === opt.label) {
                    c.classList.add('selected');
                    c.setAttribute('aria-pressed', 'true');
                  }
                });
              }
            });
          }
        }
      }
      if (s.checkedAddons && s.checkedAddons.length) {
        document.querySelectorAll('.addon-card input').forEach(function (cb) {
          if (s.checkedAddons.indexOf(cb.dataset.name) !== -1) cb.checked = true;
        });
      }
      updatePerTrackPrices();
      updateTotal();
    } catch (e) {}
  }

  /* ============================================================
     RENDER — Genres
     ============================================================ */
  function renderGenres() {
    cfg.genres.forEach(function (g) {
      var o = document.createElement('option');
      o.value = g; o.textContent = g;
      els.genre.appendChild(o);
    });
  }

  /* ============================================================
     RENDER — Effect pills — Fix #2: colours from CSS variables
     ============================================================ */
  /* ============================================================
   RENDER — Effect pills
   Fix: locked levels clearly unavailable with strikethrough + dim
   ============================================================ */
function renderEffectPills(p) {
  var maxLvl  = p.maxEffectLevels || 3;
  var labels  = (cfg.effectLevelObjects && cfg.effectLevelObjects.length)
    ? cfg.effectLevelObjects.map(function (e) { return e.label; })
    : (cfg.effectLevels || EFFECT_LEVEL_LABELS);
  var html = '<div class="detail-effect-levels">';
  for (var i = 1; i <= 5; i++) {
    var style    = getEffectLevelStyle(i);
    var label    = labels[i - 1] || EFFECT_LEVEL_LABELS[i - 1] || ('Level ' + i);
    var included = i <= maxLvl;
    if (included) {
      html += '<span class="effect-pill included" style="background:' + style.bg + ';color:' + style.text + ';">' + label + '</span>';
    } else {
      html += '<span class="effect-pill locked" title="Not available on this package">' +
              '<s>' + label + '</s></span>';
    }
  }
  html += '</div>';
  return html;
}

  function renderTransitionPills(allOpts, pkgOpts) {
  return allOpts.map(function (opt) {
    var optVal = transitionValue(opt);
    var avail  = pkgOpts.some(function (po) {
      return transitionValue(po) === optVal;
    });
    var label = transitionLabel(opt);
    return '<span class="detail-pill ' + (avail ? 'detail-pill-on' : 'detail-pill-off') + '">' +
           label + '</span>';
    }).join('');
  }

  /* ============================================================
     RENDER — Package Cards
     ============================================================ */
  function renderPackageCards() {
    ['standard', 'premium', 'elite'].forEach(function (key) {
      var p           = cfg.packages[key];
      var customCount = countCustomisationOptions(p);
      var card        = document.createElement('div');

      card.className         = 'pkg-card';
      card.dataset.pkg       = key;
      card.dataset.base      = p.basePrice;
      card.dataset.extra     = p.extraPricePerTrack;
      card.dataset.max       = p.maxTracks;
      card.dataset.effects   = p.maxEffectLevels;
      card.dataset.variantId = p.variantId;
      card.dataset.editPoints = p.editPointsPerTrack || 3;

      var statsHtml =
        '<div class="pkg-card-stats">' +
          '<div class="pkg-stat">' +
            '<span class="pkg-stat-feature">' + p.maxTracks + ' Tracks</span>' +
            '<span class="pkg-stat-desc">Use up to ' + p.maxTracks + ' songs in your edit</span>' +
          '</div>' +
          '<div class="pkg-stat">' +
            '<span class="pkg-stat-feature">' + (p.editPointsPerTrack || 3) + ' Edit Points</span>' +
            '<span class="pkg-stat-desc">Make up to ' + (p.editPointsPerTrack || 3) + ' cuts per track</span>' +
          '</div>' +
          '<div class="pkg-stat">' +
            '<span class="pkg-stat-feature">' + customCount + ' Options</span>' +
            '<span class="pkg-stat-desc">Customise with ' + customCount + ' creative choices</span>' +
          '</div>' +
        '</div>';

      var t = p.transitions || {};
      var detailsHtml =
        '<button class="pkg-details-toggle" type="button" aria-expanded="false">More details <span class="pkg-toggle-arrow">›</span></button>' +
        '<div class="pkg-details-panel">' +
          '<div>' +
            '<div class="pkg-details-section-label">Effect Levels</div>' +
            renderEffectPills(p) +
          '</div>' +
          '<div class="detail-divider"><span>Transitions</span></div>' +
          '<div>' +
            '<div class="pkg-details-section-label">Intro</div>' +
            '<div class="detail-pills">' + renderTransitionPills(ALL_INTRO, t.intro || []) + '</div>' +
          '</div>' +
          '<div>' +
            '<div class="pkg-details-section-label">Between Tracks</div>' +
            '<div class="detail-pills">' + renderTransitionPills(ALL_TRANS, t.transition || []) + '</div>' +
          '</div>' +
          '<div>' +
            '<div class="pkg-details-section-label">Outro</div>' +
            '<div class="detail-pills">' + renderTransitionPills(ALL_OUTRO, t.outro || []) + '</div>' +
          '</div>' +
          '<a href="/pages/custom-edits" class="pkg-see-more" target="_blank">See full package details →</a>' +
        '</div>';

      card.innerHTML =
        '<div class="pkg-card-hd">' +
          '<div class="pkg-shimmer"></div>' +
          '<div class="pkg-card-hd-inner">' +
            '<span class="pkg-card-name">' + p.name + '</span>' +
            '<div class="pkg-card-hd-price-wrap">' +
              '<span class="pkg-card-hd-price">' + formatPrice(p.basePrice) + '</span>' +
              '<span class="pkg-card-hd-extra">+' + formatPrice(p.extraPricePerTrack) + ' per extra track</span>' +
            '</div>' +
          '</div>' +
          statsHtml +
        '</div>' +
        '<div class="pkg-card-bd">' +
          '<p class="pkg-card-desc">' + p.description + '</p>' +
          detailsHtml +
        '</div>';

      card.addEventListener('click', function (e) {
        if (e.target.closest('.pkg-details-toggle') || e.target.closest('.pkg-see-more')) return;
        selectPackage(card);
      });

      var toggleBtn = card.querySelector('.pkg-details-toggle');
      var panel     = card.querySelector('.pkg-details-panel');
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = panel.classList.contains('open');
        document.querySelectorAll('.pkg-details-panel').forEach(function (p) { p.classList.remove('open'); });
        document.querySelectorAll('.pkg-details-toggle').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          panel.classList.add('open');
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
      });

      els.pkgCards.appendChild(card);
    });
  }

  /* ============================================================
     RENDER — Add-On Cards
     ============================================================ */
  function renderAddOns() {
    cfg.addOns.forEach(function (ao) {
      var label = document.createElement('label');
      label.className = 'addon-card';

      var cb = document.createElement('input');
      cb.type             = 'checkbox';
      cb.dataset.price    = ao.price;
      cb.dataset.perTrack = ao.perTrack ? 'true' : 'false';
      cb.dataset.name     = ao.name;
      cb.addEventListener('change', function () { saveState(); debouncedUpdateTotal(); });

      var topRow = document.createElement('div');
      topRow.className = 'addon-card-top';

      var nameSpan = document.createElement('span');
      nameSpan.className   = 'ao-name';
      nameSpan.textContent = ao.name;

      var priceSpan = document.createElement('span');
      priceSpan.className         = 'ao-price';
      priceSpan.dataset.basePrice = ao.price;
      priceSpan.textContent       = '+' + formatPrice(ao.price);

      topRow.appendChild(nameSpan);
      topRow.appendChild(priceSpan);

      var bottomRow = document.createElement('div');
      bottomRow.className = 'addon-card-bottom';

      var descSpan = document.createElement('span');
      descSpan.className   = 'ao-desc';
      descSpan.textContent = ao.description;
      bottomRow.appendChild(descSpan);

      if (ao.perTrack) {
        var calcSpan = document.createElement('span');
        calcSpan.className   = 'ao-calc';
        calcSpan.textContent = '1 track × ' + formatPrice(ao.price);
        bottomRow.appendChild(calcSpan);
      }

      label.appendChild(cb);
      label.appendChild(topRow);
      label.appendChild(bottomRow);
      els.addonsContainer.appendChild(label);
    });
  }

  /* ============================================================
     PACKAGE SELECTION
     ============================================================ */
  function selectPackage(el, silent) {
    document.querySelectorAll('.pkg-card').forEach(function (c) { c.classList.remove('selected'); });
    el.classList.add('selected');

    var key = el.dataset.pkg;
    var p   = cfg.packages[key];
    selectedPkg = {
      name:       p.name,
      key:        key,
      base:       parseFloat(el.dataset.base),
      extra:      parseFloat(el.dataset.extra),
      max:        parseInt(el.dataset.max),
      maxEffects: parseInt(el.dataset.effects),
      editPoints: parseInt(el.dataset.editPoints) || 3
    };

    trackCount = Math.min(trackCount, selectedPkg.max);

    var newOpts = cfg.packages[key].turnaroundOptions;
    if (turnaroundChoice) {
      var stillValid = newOpts.some(function (o) { return o.label === turnaroundChoice.label; });
      if (!stillValid) turnaroundChoice = null;
    }

    if (els.pkgHint) els.pkgHint.classList.remove('visible');
    els.pkgError.style.display = 'none';
    document.getElementById('cart-variant-id').value = el.dataset.variantId;

    els.trackSection.style.display      = 'block';
    els.turnaroundSection.style.display = 'block';
    els.trackLimitLabel.textContent     = 'Max ' + selectedPkg.max + ' tracks for ' + selectedPkg.name;

    renderTrackBoxes();
    renderTurnaroundOptions();
    updateTrackPriceIndicator();
    updatePerTrackPrices();
    updateTotal();

    if (!silent) saveState();
  }

  /* ============================================================
     RENDER — Track Boxes
     ============================================================ */
  function renderTrackBoxes() {
    els.trackGrid.innerHTML = '';
    for (var i = 1; i <= selectedPkg.max; i++) {
      (function (num) {
        var btn = document.createElement('button');
        btn.type        = 'button';
        btn.className   = 'track-box' + (num === trackCount ? ' selected' : '');
        btn.textContent = num;
        btn.dataset.num = num;
        btn.setAttribute('aria-label', num + ' track' + (num !== 1 ? 's' : ''));
        btn.setAttribute('aria-pressed', String(num === trackCount));
        btn.addEventListener('click', function () {
          trackCount = parseInt(this.dataset.num);
          document.querySelectorAll('.track-box').forEach(function (b) {
            b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('selected'); this.setAttribute('aria-pressed', 'true');
          updatePerTrackPrices(); updateTrackPriceIndicator(); saveState(); debouncedUpdateTotal();
        });
        els.trackGrid.appendChild(btn);
      })(i);
    }
  }

  function updateTrackPriceIndicator() {
    if (!selectedPkg || !els.trackIndicator) return;
    els.trackIndicator.textContent = trackCount === 1
      ? ''
      : formatPrice(selectedPkg.base) + ' + ' + formatPrice((trackCount - 1) * selectedPkg.extra) + ' = ' + formatPrice(calcPkg());
  }

  /* ============================================================
     RENDER — Turnaround Options
     ============================================================ */
  function renderTurnaroundOptions() {
    els.turnaroundGrid.innerHTML = '';
    var opts = cfg.packages[selectedPkg.key].turnaroundOptions;
    opts.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type          = 'button';
      btn.className     = 'turnaround-card';
      btn.dataset.label = opt.label;
      btn.setAttribute('aria-pressed', 'false');

      if (turnaroundChoice && turnaroundChoice.label === opt.label) {
        btn.classList.add('selected'); btn.setAttribute('aria-pressed', 'true');
        turnaroundChoice = opt;
      }

      var adj = opt.priceAdjustment === 0
        ? 'Included'
        : (opt.priceAdjustment > 0 ? '+' + formatPrice(opt.priceAdjustment) : '−' + formatPrice(Math.abs(opt.priceAdjustment)));

      var badgeHtml = opt.priceAdjustment < 0
        ? '<span class="t-badge">Save ' + formatPrice(Math.abs(opt.priceAdjustment)) + '</span>'
        : '';

      btn.innerHTML =
        '<span class="t-label">' + opt.label + '</span>' +
        badgeHtml +
        '<span class="t-price">' + adj + '</span>';

      btn.addEventListener('click', function () {
        turnaroundChoice = opt;
        document.querySelectorAll('.turnaround-card').forEach(function (c) {
          c.classList.remove('selected'); c.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('selected'); this.setAttribute('aria-pressed', 'true');
        saveState(); debouncedUpdateTotal();
      });

      els.turnaroundGrid.appendChild(btn);
    });
  }

  /* ============================================================
     PRICE HELPERS
     ============================================================ */
  function calcPkg() {
    return selectedPkg ? selectedPkg.base + (trackCount - 1) * selectedPkg.extra : 0;
  }

  function updatePerTrackPrices() {
    document.querySelectorAll('.addon-card input[data-per-track="true"]').forEach(function (cb) {
      var card      = cb.parentElement;
      var priceSpan = card.querySelector('.ao-price');
      var calcSpan  = card.querySelector('.ao-calc');
      if (!priceSpan) return;
      var base = parseFloat(priceSpan.dataset.basePrice);
      priceSpan.textContent = '+' + formatPrice(base * trackCount);
      if (calcSpan) calcSpan.textContent = trackCount + ' track' + (trackCount !== 1 ? 's' : '') + ' × ' + formatPrice(base);
    });
  }

  /* Fix #18: edit points shown in summary ── */
  function updateTotal() {
    if (!selectedPkg) return;
    var pt = calcPkg();
    if (els.summaryPkg) els.summaryPkg.style.display = 'none';

    var rows = '';
    rows += '<div class="summary-row"><span>' + selectedPkg.name + ' · ' + trackCount +
            ' track' + (trackCount !== 1 ? 's' : '') + '</span><span>' + formatPrice(pt) + '</span></div>';

    if (turnaroundChoice) {
      var tadj = turnaroundChoice.priceAdjustment;
      var tstr = tadj === 0 ? 'Included' : (tadj > 0 ? '+' + formatPrice(tadj) : '−' + formatPrice(Math.abs(tadj)));
      rows += '<div class="summary-row"><span>Turnaround: ' + turnaroundChoice.label + '</span><span>' + tstr + '</span></div>';
    }

    var at = 0;
    var addonRows = '';
    document.querySelectorAll('.addon-card input:checked').forEach(function (cb) {
      var lbl = cb.dataset.name;
      var ipt = cb.dataset.perTrack === 'true';
      var p   = parseFloat(cb.dataset.price) * (ipt ? trackCount : 1);
      at += p;
      addonRows += '<div class="summary-row"><span>' + lbl + (ipt ? ' (×' + trackCount + ')' : '') + '</span><span>+' + formatPrice(p) + '</span></div>';
    });

    if (addonRows) {
      rows += '<div class="summary-row" style="border-bottom:none;padding-bottom:2px;margin-top:6px;">' +
              '<span style="font-size:0.72rem;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--ce-muted);">Add-Ons</span>' +
              '<span></span></div>';
      rows += addonRows;
    }

    els.summaryRows.innerHTML = rows;
    var total = pt + (turnaroundChoice ? turnaroundChoice.priceAdjustment : 0) + at;
    els.summaryTotalRow.style.display = 'flex';
    els.summaryTotalRow.className     = 'summary-total-row';
    els.summaryTotalRow.innerHTML     = '<span>Total</span><span>' + formatPrice(total) + '</span>';
    document.getElementById('cart-total').value = formatPrice(total) + ' (' + currency + ')';
  }


  /* ============================================================
     SCROLL HINT
     ============================================================ */
  function initScrollHint() {
    if (!els.pkgHint) return;
    var pkgSection = document.getElementById('pkg-cards-container');
    if (!pkgSection) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && !selectedPkg) els.pkgHint.classList.add('visible');
      });
    }, { threshold: 0 }).observe(pkgSection);
  }

  /* ============================================================
   CONFIRMATION MODAL — fixed centre overlay, visible at all scroll positions
   ============================================================ */
  function showConfirmModal(onConfirm) {
    var overlay = els.confirmOverlay;
    var body    = overlay.querySelector('.pkg-confirm-modal-bd');
    body.innerHTML = els.summaryRows.innerHTML;
    var totalClone = document.createElement('div');
    totalClone.className = 'summary-total-row';
    totalClone.innerHTML = els.summaryTotalRow.innerHTML;
    body.appendChild(totalClone);

    overlay.hidden = false;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var goBtn     = overlay.querySelector('.pkg-confirm-go');
    var cancelBtn = overlay.querySelector('.pkg-confirm-cancel');

    function close() {
      overlay.hidden = true;
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      goBtn.removeEventListener('click', handleGo);
      cancelBtn.removeEventListener('click', close);
      overlay.removeEventListener('click', handleBackdrop);
    }
    function handleGo() { close(); onConfirm(); }
    function handleBackdrop(e) { if (e.target === overlay) close(); }

    goBtn.addEventListener('click', handleGo);
    cancelBtn.addEventListener('click', close);
    overlay.addEventListener('click', handleBackdrop);

    // Trap focus inside modal
    var modal = overlay.querySelector('.pkg-confirm-modal');
    var focusable = modal.querySelectorAll('button');
    if (focusable.length) focusable[0].focus();
  }


  /* ============================================================
     FORM SUBMISSION
     ============================================================ */
  function validateForm() {
    var errs = [];
    if (!selectedPkg)                errs.push('Please select a package.');
    if (!turnaroundChoice)           errs.push('Please select a turnaround time.');
    if (!els.editTitle.value.trim()) errs.push('Please enter your edit title.');
    if (!els.genre.value)            errs.push('Please select a dance genre.');
    return errs;
  }

  function populateHiddenFields() {
    var pt = calcPkg(), at = 0, al = [];
    document.querySelectorAll('.addon-card input:checked').forEach(function (cb) {
      var lbl = cb.dataset.name;
      var ipt = cb.dataset.perTrack === 'true';
      var p   = parseFloat(cb.dataset.price) * (ipt ? trackCount : 1);
      al.push(lbl + ' (+$' + p.toFixed(0) + ')'); at += p;
    });
    var total = pt + turnaroundChoice.priceAdjustment + at;
    var tadj  = turnaroundChoice.priceAdjustment;
    document.getElementById('cart-edit-title').value  = els.editTitle.value.trim();
    document.getElementById('cart-genre').value       = els.genre.value;
    document.getElementById('cart-pkg').value         = selectedPkg.name + ' ($' + selectedPkg.base + ' first, +$' + selectedPkg.extra + ' each after)';
    document.getElementById('cart-tracks').value      = trackCount;
    document.getElementById('cart-turnaround').value  = turnaroundChoice.label + (tadj !== 0 ? ' (+$' + tadj + ')' : '');
    document.getElementById('cart-addons').value      = al.length ? al.join(', ') : 'None';
    document.getElementById('cart-total').value       = formatPrice(total) + ' (' + currency + ')';
    return { total: total };
  }

  /* Fix #16: improved error messaging ── */
  async function doSubmit() {
    var btn = els.submitBtn;
    btn.disabled = true; btn.textContent = 'Processing...';
    var fields     = populateHiddenFields();
    var controller = new AbortController();
    var timeout    = setTimeout(function () { controller.abort(); }, 8000);
    try {
      var res = await fetch('https://custom-edit.netlify.app/.netlify/functions/create-draft-order', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          variantId:  document.getElementById('cart-variant-id').value,
          quantity:   1,
          properties: {
            'Edit Title':            els.editTitle.value.trim(),
            'Dance Genre':           els.genre.value,
            'Package':               document.getElementById('cart-pkg').value,
            'Tracks':                String(trackCount),
            'Turnaround':            document.getElementById('cart-turnaround').value,
            'Add-Ons':               document.getElementById('cart-addons').value,
            'Total':                 document.getElementById('cart-total').value,
            'Edit Points Per Track': String(cfg.packages[selectedPkg.key].editPointsPerTrack || 3)
          },
          total: String(fields.total), currencyCode: currency
        })
      });
      clearTimeout(timeout);
      if (!res.ok) {
        var errBody = '';
        try { errBody = (await res.json()).error || ''; } catch (e) {}
        throw new Error(errBody || 'Server error (' + res.status + ')');
      }
      var data = await res.json();
      if (!data.invoiceUrl) throw new Error('No invoice URL returned. Please contact support.');
      try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      window.location.href = data.invoiceUrl;
    } catch (err) {
      clearTimeout(timeout);
      console.error('[pkg-builder] Submit error:', err);
      var msg = 'Something went wrong. Please try again.';
      if (err.name === 'AbortError') {
        msg = 'Request timed out — please check your connection and try again.';
      } else if (err.message && err.message.length < 120) {
        msg = err.message;
      }
      els.formError.style.display = 'block';
      els.formError.textContent   = msg;
      btn.disabled = false; btn.textContent = 'Confirm & Pay →';
      submitCooldown = false;
    }
  }

  function submitForm() {
    if (submitCooldown) return;
    var errs = validateForm();
    if (errs.length) { els.formError.style.display = 'block'; els.formError.innerHTML = errs.join('<br>'); return; }
    els.formError.style.display = 'none';
    submitCooldown = true;
    setTimeout(function () { submitCooldown = false; }, 3000);
    showConfirmModal(doSubmit);
  }

  /* ============================================================
     RESET
     ============================================================ */
  function resetForm() {
    selectedPkg = null; trackCount = 1; turnaroundChoice = null;
    document.querySelectorAll('.pkg-card').forEach(function (c) { c.classList.remove('selected'); });
    document.querySelectorAll('.addon-card input').forEach(function (cb) { cb.checked = false; });
    els.editTitle.value = ''; els.genre.value = '';
    els.trackSection.style.display = 'none'; els.turnaroundSection.style.display = 'none';
    els.trackGrid.innerHTML = ''; els.turnaroundGrid.innerHTML = ''; els.trackIndicator.textContent = '';
    if (els.summaryPkg) { els.summaryPkg.style.display = 'block'; els.summaryPkg.textContent = 'No package selected yet.'; }
    els.summaryRows.innerHTML = ''; els.summaryTotalRow.style.display = 'none'; els.summaryTotalRow.innerHTML = '';
    els.successBanner.style.display = 'none'; els.pkgError.style.display = 'none'; els.formError.style.display = 'none';
    if (els.pkgHint) els.pkgHint.classList.remove('visible');
    updatePerTrackPrices();
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  window.submitForm = submitForm;
  window.resetForm  = resetForm;

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    els = {
      editTitle:         document.getElementById('edit-title'),
      genre:             document.getElementById('dance-genre'),
      pkgCards:          document.getElementById('pkg-cards-container'),
      pkgError:          document.getElementById('pkg-error'),
      pkgHint:           document.getElementById('pkg-section-hint'),
      trackSection:      document.getElementById('track-section'),
      turnaroundSection: document.getElementById('turnaround-section'),
      trackGrid:         document.getElementById('track-box-grid'),
      trackLimitLabel:   document.getElementById('track-limit-label'),
      trackIndicator:    document.getElementById('track-price-indicator'),
      turnaroundGrid:    document.getElementById('turnaround-grid'),
      addonsContainer:   document.getElementById('addons-container'),
      summaryPkg:        document.getElementById('summary-pkg'),
      summaryRows:       document.getElementById('summary-rows'),
      summaryTotalRow:   document.getElementById('summary-total-row'),
      submitBtn:         document.querySelector('#pkg-cart-form button'),
      formError:         document.getElementById('form-error'),
      successBanner:     document.getElementById('success-banner'),
      confirmOverlay:    document.getElementById('pkg-confirm-overlay')
    };
    renderGenres(); renderPackageCards(); renderAddOns();
    restoreState(); initScrollHint();
    var wrapper = document.querySelector('.pkg-builder-wrapper');
    if (wrapper) wrapper.classList.add('loaded');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
